
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from 'react';
import { UIMixin } from "../../../mixins/uiMixin";
import { connect } from "react-redux";
import { CASHOUT_MONEY_CASH } from '../../../actions/actionTypes';

class CashoutByTicket extends Component {
    constructor (props) {
        super(props);
        this.cashoutByTicket = this.cashoutByTicket.bind(this);
    }
    cashoutByTicket () {
        return () => {
            this.props.dispatch({type: CASHOUT_MONEY_CASH});
            // eslint-disable-next-line react/prop-types
            this.props.closePopup()();
        };
    }
    render () {
        // eslint-disable-next-line no-undef
        return Template.default.apply(this);
    }
}
const mapStateToProps = state => {
    return {
        user: state.user
    };
};
export default connect(mapStateToProps)(UIMixin({Component: CashoutByTicket}));